var map = {
	"./Word_Cards.png": 1586,
	"./aiBtn.png": 7214,
	"./app.scss": 7276,
	"./btn/arrowLeft.png": 5699,
	"./btn/arrowRight.png": 7996,
	"./btn/btn_ch_off.svg": 8408,
	"./btn/btn_ch_on.svg": 4394,
	"./btn/btn_close_black.png": 7004,
	"./btn/btn_close_white.png": 2328,
	"./btn/btn_en_off.svg": 8196,
	"./btn/btn_en_on.svg": 9581,
	"./btn/btn_menu.png": 7477,
	"./btn/btn_video.png": 6112,
	"./btn/btn_voice.png": 6869,
	"./closeAI.png": 4953,
	"./default_cover.png": 7637,
	"./font/Cubic_11_1.013_R.ttf": 4451,
	"./font/fonts.css": 6564,
	"./icon/caret-right-solid.svg": 8828,
	"./icon/list.svg": 862,
	"./icon/repeat_off.png": 8818,
	"./icon/repeat_on.png": 1225,
	"./icon/unit.svg": 5862,
	"./login_icon.png": 7634,
	"./logo-abc.png": 939,
	"./logo-all.png": 1029,
	"./logo-biz.png": 1905,
	"./logo-cnn.png": 2472,
	"./logo-jp.png": 6839,
	"./logo-live.png": 5660,
	"./magazine.scss": 4644,
	"./openAI.png": 2865,
	"./pattern-WAR_text.png": 8824,
	"./pic_head_bg.png": 6188,
	"./pic_live_logo.png": 7911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;